export const AddressList = [
  { id: 1, value: "Baker Street 15" },
  { id: 2, value: "High Avanue 17" },
  { id: 3, value: "Walker Street 244" },
  { id: 4, value: "Downing Street 1" },
];

export const AddressDietList = [
  { id: 1, value: "slim 1500" },
  { id: 2, value: "wege 2000" },
  { id: 3, value: "keto 3000" },
  { id: 4, value: "sport 1500" },
];

export const DietParts = [
  { id: "1/1", value: "1/1" },
  { id: "1/2", value: "1/2" },
  { id: "2/2", value: "2/2" },
  { id: "1/3", value: "1/3" },
  { id: "2/3", value: "2/3" },
  { id: "3/3", value: "3/3" },
  { id: "1/4", value: "1/4" },
  { id: "2/4", value: "2/4" },
  { id: "3/4", value: "3/4" },
  { id: "4/4", value: "4/4" },
  { id: "1/5", value: "1/5" },
  { id: "2/5", value: "2/5" },
  { id: "3/5", value: "3/5" },
  { id: "4/5", value: "4/5" },
  { id: "5/5", value: "5/5" },
];
